import i18n from '@/utils/i18n';
import LightningIcon from '@assets/icons/lightning.svg';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import {
  Insets,
  StyleProp,
  TouchableOpacity,
  View,
  ViewStyle,
} from 'react-native';

interface Props {
  height?: number;
  hitSlop?: Insets;
  onPress: () => void;
  salesRepModeEnabled: boolean;
  style?: StyleProp<ViewStyle>;
  width?: number;
}

export const SalesRepButton: React.FC<Props> = ({
  height = 25 / 1.2,
  hitSlop,
  onPress,
  salesRepModeEnabled,
  style,
  width = 22 / 1.2,
}) => {
  const [styles] = useStyles();
  return (
    <TouchableOpacity
      accessibilityLabel={
        salesRepModeEnabled
          ? i18n.t('disable_sales_rep_mode')
          : i18n.t('enable_sales_rep_mode')
      }
      hitSlop={hitSlop}
      onPress={onPress}
      style={style}
      testID="sales-rep-button"
    >
      <View style={[styles.circle, salesRepModeEnabled ? styles.active : null]}>
        <LightningIcon height={height} width={width} />
      </View>
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  active: {
    backgroundColor: theme.colors.pepperGreen,
  },
  circle: {
    alignItems: 'center',
    backgroundColor: theme.colors.inactiveFill,
    borderRadius: 16,
    height: 32,
    justifyContent: 'center',
    width: 32,
  },
}));
